export default __webpack_public_path__ + "static/media/logo_kemeskes.3e856cab.png";